import { Fragment } from 'react';
import clock from '../img/clock-icon.jpeg';
import classes from './Firstview.module.css';
import chart from '../img/chart.jpeg';
import rocket from '../img/rocket.jpeg';
import CountUp from 'react-countup';

function Firstview(){
return (
<Fragment>
<div className={classes.container}>
    <div className={classes.item}>

    <h2 className={classes.imgdescribtion}> <span> + <CountUp end={5}  duration={2.5} className={classes.countupnumber}/> Real World Projects</span></h2>
    </div>


    <div className={classes.item}>
   
    <h2 className={classes.imgdescribtion}><span> + <CountUp end={34}  duration={2.5} className={classes.countupnumber}/> Templates</span></h2>
    </div>


    <div className={classes.item}>
 
    <h2 className={classes.imgdescribtion}>+ <span> <CountUp end={6}  duration={2.5} className={classes.countupnumber}/>  Courses</span></h2>
    </div>
</div>

</Fragment>
)

}
export default Firstview;